import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScroll = ({ from, to }: { from: number; to: number }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      left: from,
      top: to,
      behavior: 'smooth',
    });
  }, [location, from, to]);
};
